var msg = new Array();
msg['ERR_PRIVACY']='Tienes que aceptar la declaración de privacidad';
msg['ERR_CONTRACT']='Usted debe aceptar las condiciones del contrato de dropshipping';
msg['ERR_MISSINGFIELDS']='Rellena todos los campos obligatorios';
msg['ERR_FILLEMAILFIELD']='Rellena los campos del correo electrónico';
msg['ERR_USEREXISTS']='Usuario existente';
msg['ERR_INVALIDMAIL']='Correo electrónico no valido';
msg['ERR_CLIENTMANDATORYFIELDS']='Rellena todos los campos obligatorios';
msg['ERR_NOSIZESELECTED']='Tienes que seleccionar la talla';
msg['ERR_LOGINREQUIRED']='Login solicitado';
msg['ERR_LOGININVALID']='Correo electrónico o contraseña no validos';
msg['ERR_CARRIERMISSING']='Antes tienes que seleccionar un tipo de envío';
msg['ERR_CARRIER_COST_MISSING']='Costos del transportador no disponibles por el país seleccionado y por el peso del pedido';
msg['ERR_SHORTPASSWORD']='la contraseña debe tener al menos :length caracteres';
msg['ERR_PASSWORDCONFIRM']='Las contraseñas no coinciden';
msg['ERR_PASSWORDCOMPLEX']='Password must be at least 8 characters long and contain both uppercase and lowercase characters';
msg['ERR_WRONG_TOKEN']='Incorrect password recovery code';
msg['ERR_SYNC2FASHION_URL']='Invalid URL, must NOT start with http(s)://';
msg['ERR_ZIP_FORMAT']='El código postal debe constar exactamente de 5 dígitos';
msg['MSG_ALREADY_RETURNED']='La solicitud de devolución ya existe';
msg['MSG_DEFERRED_DISPATCH_COMPUTATION']='Solamente los pedidos reservados serán habilitados y los costos de la entrega serán escritos a trevés de correo electrónico';
msg['MSG_ADDEDTOWISHLIST']='Producto añadido a tu lista de deseos';
msg['MSG_REMOVEDTOWISHLIST']='Producto eliminado de la lista de deseos';
msg['MSG_REMOVEDFROMCART']='Producto retirado del carrito';
msg['MSG_ADDEDTOCART']='Productos añadidos a tu carro';
msg['MSG_WAIT']='Espera por favor...';
msg['MSG_SUBJECT_PRODUCTSHARE']=' compartir algo contigo';
msg['MSG_SENDER_PRODUCTSHARE']='Tu nombre';
msg['MSG_MESSAGE_PRODUCTSHARE']='Mensaje';
msg['MSG_MAILSENT']='E-Mails enviados';
msg['MSG_MIXED_INTANGIBLE']='En el carro hay productos que pertenecen a una venta que no pueden estar en el carro juntos a este producto';
msg['MSG_MIXED_CART']='El producto que quieres añadir se encuentra en un diferente almacén, por lo tanto tienes que crear otro pedido';
msg['MSG_INSUFFICIENT_STOCK']='Lo siento, en este momento no tenemos suficientes productos disponibles';
msg['MSG_APPLIEDVATCHANGED']='Dopo questo aggiornamento dei dati di fatturazione, l\'IVA applicata al tuo ordine è cambiata';
msg['MSG_GENERIC_ERROR']='Lo siento, hay un error. ';
msg['MSG_COUPON_ERROR']='Codice coupon inserito non valido o inserito precedentemente';
msg['MSG_COUPON_VALID']='Codice coupon inserito validato con successo';
msg['MSG_RECOVEREMAILSENT']='Revisa tu correo electrónico y haz clic sobre el enlace para confirmar el cambio';
msg['MSG_RECOVEREMAILSENT_ERROR']='Atención: no estás registrado con esta dirección de correo electrónico o ya está restableciendo su contraseña';
msg['MSG_EXTRAUELIMIT']='La cifra m�nima de su pedido no puede ser inferior a 500.00€';
msg['MSG_RULE_REJECT']='Product cannot be added to cart because of rule :rule';
msg['LABEL_ARTICLES']='artículos';
msg['LABEL_WARNING']='aviso';
msg['LABEL_NOTAPPLICABLE']='No aplicable';
msg['LABEL_ALREADYREGISTEREDUSERES']='Already registered users';
msg['LABEL_SENTINVITES']='Sent invites';
msg['LABEL_NOTSENTINVITES']='Unsent invites';
msg['LABEL_INVITES_ALREADY_SENT']='Users already invited';
msg['LABEL_SUBMIT']='Submit';
msg['LABEL_SELECTALL']='Select all';
msg['MSG_MESSAGE_SENT']='Mensaje enviado con éxito';
msg['MSG_RETURN_REQUEST_SUCCESS'] = 'Solicitud de devolución creada con éxito';
msg['MSG_SAVE_SUCCESS'] = 'Guardar con éxito';
msg['MSG_SUBSCRIBED'] = 'Iscritto con successo';
msg['MSG_PROFILECONSENT_SAVED'] = 'Sus preferencias de contacto han sido actualizadas';
msg['MSG_PASSWORD_NOT_EQUAL'] = 'passwords don\'t match';
msg['MSG_PASSWORD_MODIFIED'] = 'Password modified successfully';
msg['DELETEALLPRODUCTSERROR']='Error al eliminar productos del carrito';
msg['MSG_DELETEALLPRODUCTS']='¿Está seguro de que quiere eliminar todos los productos del carrito?';
msg['MSG_PEC_SDI_INCOMPLETE']='Introduzca al menos un campo entre PEC y SDI';
msg['MSG_ATTACHMENT_UPLOADED'] = 'Attachment uploaded successfully';
msg['ERR_ATTACHMENT_UPLOAD_FAIL'] = 'File could not be uploaded';
msg['MSG_ATTACHMENT_DELETED'] = 'Attachment deleted';
msg['ERR_NO_ATTACHMENT_TO_DELETE'] = 'No attachment to delete found';
msg['login.user.unexisting']='User does not exist';
msg['login.user.passwordnotcomplexenought']=msg['ERR_PASSWORDCOMPLEX'];
msg['You can only have one subscription active.']='You can only have one subscription active';
msg['msg.order.vatchanged']='Billing country must not be changed';
msg['msg.form.invalidtype'] = 'Se ha producido un error. Póngase en contacto con la administración informando de lo siguiente: "Tipo de contacto inválido o faltante."';
msg['msg.form.invalidemail'] = 'Email no válido o ausente';
msg['msg.form.invalidrecipients'] = 'Se ha producido un error. Ponte en contacto con la administración informando de lo siguiente: "Destinatario de contacto no válido o ausente."';

var portal_livestock_available='DISPONIBLE';
var portal_livestock_soldout='AGOTADO';

var activity_online_shop = 'tienda en linea';
var activity_shop = 'tienda';
var activity_private_sales = 'ventas privadas';
var activity_outlet = 'outlet';
var activity_online_outlet = 'outlet en linea';
var activity_store_chain = 'cadena de tiendas';
var activity_purchasing_group = 'grupo de compras';
var activity_broker = 'broker/agente';
var activity_ebay_amazon = 'tienda ebay/amazon';
var activity_other = 'otro';

var general="General";
var general_personaldata='Datos personales';
var general_olduser='Usuario registrado';
var general_newuser='Nuevo usuario';
var general_username="Nombre de usuario";
var general_password="Contraseña";
var general_contacts="Contactos";
var general_choosesize="Elija al menos una talla";
var general_phone="Teléfono";
var general_skype="Skype";
var general_website="Sitio Web";
var general_fax="Fax";
var general_firstname='Nombre';
var general_lastname='Apellidos';
var general_company='Empresa';
var general_birth='Fecha de nacimiento';
var general_code='Código';
var general_model='Modelo';
var general_quantity='Cantidad';
var general_availability='Disponibilidad';
var general_price='Precio';
var general_warning='Atención';
var general_dispatchto='Destinatario';
var general_careof='A la atención de';
var general_vat='N°Id.Fiscal, N°IVA';
var general_address='Dirección';
var general_addresstype='Tipo calle';
var general_addressnumber='Número';
var general_city='Ciudad';
var general_prov='Provincia';
var general_zip='C.P';
var general_mobile='Tel. móvil';
var general_notes='Notas';
var general_orders='Pedidos';
var general_fgfdiscounts='Amigos y descuentos';
var general_myprofile='Mi perfil';
var general_pieces='un';
var general_size_table='Cuadro de Tallas';
var general_details='Detalles';
var general_invoice='Factura';
var general_creditnote='Nota de crédito';
var general_cart= 'Cesta';
var general_country='País';
var general_carrier='Correo';
var general_dispatch_address='Dirección de entrega';
var general_invoice_address='Dirección de facturación';
var general_receive_newsletter='Recibir Boletín informativo';
var general_copydispatchfrombilldata='Copiar de los datos de facturación';
var general_instructions="Istrucciones";
var general_add="Añadir";
var general_status="Estado";
var general_toomanyfilters="Se ha alcanzado el número máximo de filtros permitidos";

var help_addresstype='Calle, Plaza, Avenida, ...';
var help_address='Escriba el nombre de la  calle';
var help_dispatchmobile='Escriba un número de teléfono de contacto para la entrega';
var help_ordercfpiva='Si deja este campo en blanco, al valor del pedido se le aplicará el valor de IVA predeterminado';
var help_cf='Escriba su número de identificación fiscal';

var buttons_save='Guardar';
var buttons_cancel='Cancelar';
var buttons_changepw='Cambiar la contraseña';
var buttons_close='Cerrar';
var buttons_continue='Continuar';
var buttons_confirm='Aceptar';
var buttons_invite='Invitar';
var buttons_continueshopping='Continuar las compras';
var buttons_gocheckout='Ir a la caja';

var messages_product_soldout='El producto está agotado';
var messages_noselection='La selección está vacía';
var messages_invaliddata='Rellene correctamente todos los campos';
var messages_recoverpassword='Recuperar la contraseña';
var messages_recoverpassword_info='Escriba la dirección de correo electrónico que utilizó para registrarse. <br/>Se le enviará un e-mail con las instrucciones para configurar una nueva contraseña';
var messages_invitefriends='Invitar a los amigos';
var messages_confirmpassword='Aceptar la contraseña';
var messages_sendingmail='Enviando e-mails...';
var messages_mailsent='E-mails enviadas correctamente';
var messages_password='Contraseña';
var messages_confirmpassword='Aceptar la contraseña';
var messages_requiredfield='Campo requerido';

var subscribe_personaldata='Tratamiento de los datos';
var subscribe_privacyintro='Para continuar la inscripción es necesario leer las normas sobre la privacidad y expresar el consentimiento para el tratamiento de los datos personales';
var subscribe_privacydisclaimer='Debe aceptar el documento informativo sobre la privacidad para completar el registro.'
var subscribe_privacy1='El que suscribe declara haber leído y aceptado el documento informativo sobre la privacidad';
var subscribe_privacy2='El que suscribe autoriza a comunicar sus datos a otras compañías para fines de carácter comercial (facultativo)';

var order_status='Estado'
var order_date='Fecha'
var order_dispatchdate='Enviado';

var returnedgoods_requests="Solicitudes de devolución";
var returnedgoods_motivations="Motivo de la devolución";
var returnedgoods_requestcode="Código de la devolución";
var returnedgoods_requestdate="Solicitado el";
var returnedgoods_motivations_1="El producto no es de mi agrado";
var returnedgoods_motivations_2="El producto es demasiado grande/pequeño";
var returnedgoods_motivations_3="El producto está dañado";
var returnedgoods_motivations_4="El producto recibido no corresponde al producto encargado";
var returnedgoods_motivations_5="El producto no se encuentra en el empaque";
var returnedgoods_motivations_other="Otros motivos";

var i18nOrderStatus = new Array();
i18nOrderStatus[0]='Pendiente';
i18nOrderStatus[1]='En pago';
i18nOrderStatus[2]='Confirmado';
i18nOrderStatus[3]='Enviado';
i18nOrderStatus[4]='Entregado';
i18nOrderStatus[5]='Reservado';
i18nOrderStatus[6]='Drop shipping';
i18nOrderStatus[2000]='Anulado';
i18nOrderStatus[2001]='Error';
i18nOrderStatus[3001]='En procesamiento';
i18nOrderStatus[3002]='Listo';

i18nOrderStatus[1000]='Pago Cancelado';
i18nOrderStatus[2002]='Error de verificación del pago';
i18nOrderStatus[2003]='Reembolsado';
i18nOrderStatus[2005]='Rechazado';
i18nOrderStatus[3003]='No se puede enviar';
i18nOrderStatus[5001]='No autorizado';
i18nOrderStatus[5002]='Autorizado';
i18nOrderStatus[5003]='Drop shipping - Growing';
